enum SurveyQuestionType {
  TEXT = 'Text',
  NUMERIC_INPUT = 'NumericInput',
  NUMERIC_SLIDER = 'NumericSlider',
  MULTIPLE_CHOICE = 'MultipleChoice',
  INTRODUCTION = 'Introduction',
  CHAPTER_INTRODUCTION = 'ChapterIntroduction',
}

export default SurveyQuestionType;
